import { ApolloClient, InMemoryCache } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';

export const apolloClient = new ApolloClient({
    link: new RestLink({
        uri: process.env.REACT_APP_API_URL,
    }),
    cache: new InMemoryCache({
        typePolicies: {
            Query: {
                fields: {
                    establecimientos: {
                        merge: true,
                    }
                },
            },
        },
    }),
});
